var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.7H8a.8.8 0 00-.8.8v18a.8.8 0 00.8.8h8a.8.8 0 00.8-.8v-18a.8.8 0 00-.8-.8zM8 1.5a2 2 0 00-2 2v18a2 2 0 002 2h8a2 2 0 002-2v-18a2 2 0 00-2-2H8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4a.5.5 0 01.5-.5h1.5a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAyLjdIOEM3LjU1ODE3IDIuNyA3LjIgMy4wNTgxNyA3LjIgMy41VjIxLjVDNy4yIDIxLjk0MTggNy41NTgxNyAyMi4zIDggMjIuM0gxNkMxNi40NDE4IDIyLjMgMTYuOCAyMS45NDE4IDE2LjggMjEuNVYzLjVDMTYuOCAzLjA1ODE3IDE2LjQ0MTggMi43IDE2IDIuN1pNOCAxLjVDNi44OTU0MyAxLjUgNiAyLjM5NTQzIDYgMy41VjIxLjVDNiAyMi42MDQ2IDYuODk1NDMgMjMuNSA4IDIzLjVIMTZDMTcuMTA0NiAyMy41IDE4IDIyLjYwNDYgMTggMjEuNVYzLjVDMTggMi4zOTU0MyAxNy4xMDQ2IDEuNSAxNiAxLjVIOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMTAuNzUgNEMxMC43NSAzLjcyMzg2IDEwLjk3MzkgMy41IDExLjI1IDMuNUgxMi43NUMxMy4wMjYxIDMuNSAxMy4yNSAzLjcyMzg2IDEzLjI1IDRDMTMuMjUgNC4yNzYxNCAxMy4wMjYxIDQuNSAxMi43NSA0LjVIMTEuMjVDMTAuOTczOSA0LjUgMTAuNzUgNC4yNzYxNCAxMC43NSA0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgPhone as ReactComponent };